import React, { useState, useRef } from 'react';
import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { MapContainer, TileLayer, Circle, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import SpacesService from '../../../api/spaces.service';
import { useParams } from "react-router";
import { useLocation } from 'react-router-dom';

const REDLORE_RED = '#b60703';

const CenteredCircle = ({ radiusKm, center, onCenterChange, followMapCenter }) => {
    useMapEvents(
        followMapCenter
            ? {
                move: (e) => {
                    const newCenter = e.target.getCenter();
                    onCenterChange(newCenter);
                },
            }
            : {}
    );

    return (
        <Circle
            center={center}
            radius={radiusKm}
            pathOptions={{
                color: REDLORE_RED,
                fillColor: REDLORE_RED,
                fillOpacity: 0.3,
            }}
        />
    );
};


const GeoUpload = () => {
    const history = useHistory();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const isEdit = params.get('edit') === 'true';
    const [title, setTitle] = useState("");
    const [sliderValue, setSliderValue] = useState(0.1);
    const [centerCoords, setCenterCoords] = useState({ lat: 0, lng: 0 });
    const [mapCenter, setMapCenter] = useState({ lat: 0, lng: 0 });
    const [loading, setLoading] = useState(true);
    const { spaceId } = useParams();
    const downloadTargetRef = useRef();

    function closePopup() {
        history.goBack();
    }

    const sliderToRadius = (value) => {
        console.log(value)
        const min = 1000;
        const max = 100000;
        return min * Math.pow(max / min, value); // logarithmic scale
    };

    const radiusToSlider = (radiusKm) => {
        const min = 1000;
        const max = 100000;
        return Math.log(radiusKm / min) / Math.log(max / min);
    };

    const handleSliderChange = (e) => setSliderValue(parseFloat(e.target.value));

    const handleCancel = () => {
        history.goBack();
    };

    useEffect(() => {
        SpacesService.getSpace(spaceId)
            .then((space) => {
                console.log("space", space)
                setTitle(space?.data?.data?.name)
                const apiCenter = space?.data?.data?.geoCoordinates;
                const radius = space?.data?.data?.data?.radius;
                console.log("Array.isArray(apiCenter)", Array.isArray(apiCenter))
                console.log("typeof radius", typeof radius)
                console.log("apiCenter.length", apiCenter.length)
                console.log("apiCenter", apiCenter)

                if (
                    Array.isArray(apiCenter) &&
                    apiCenter.length > 0 &&
                    Array.isArray(apiCenter[0]) &&
                    apiCenter[0].length === 2 &&
                    typeof radius === 'number'
                ) {
                    const [lat, lng] = apiCenter[0];

                    setCenterCoords({ lat, lng });
                    setMapCenter({ lat, lng });
                    setSliderValue(radiusToSlider(radius));
                }
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    }, [spaceId]);


    const handleDone = () => {
        const radius = sliderToRadius(sliderValue);
        console.log("centerCoords, radius", centerCoords, radius)
        SpacesService.updateGeoCoordinatesCircle(spaceId, [[centerCoords.lat, centerCoords.lng]], radius)
            .then((value) => {
                console.log('API response:', value);
                history.goBack();
                // You can do something with the response here
            })
            .catch((err) => {
                console.error('API error:', err);
            });
    };

    if (loading) return <div>Loading…</div>;

    return (
        <div style={{ width: '100%', height: '100%', padding: '1rem' }}>
            <div className="spaceFloorplan" id="full-page-content-floorplan" ref={downloadTargetRef}>
                <div className="spaceFloorplan-bounds">
                    <div className="spaceFloorplan-title">
                        {title}

                        {/* {props.location.state.title}
                            <div className='uploadBtnAssetsReport upload3' style={{display: showReportBtn ? 'block' : 'none', right: "75px", top: "50px" }}>
                              <button id="generatePdfButton" alt="Download Report" title="Download Report" type="button" onClick={() => captureComponent()}>
                                <img src="../icons/reports.svg" alt="Download Report" />
                              </button>
                            </div> */}
                        <div className="spaceFloorplan-close">
                            <i className="dx-icon-close" onClick={closePopup}></i>
                        </div>
                    </div>
                    <div className="spaceFloorplan-leaflet" >
                        <MapContainer
                            center={mapCenter}
                            const zoom={Math.log2((2 * Math.PI * 6378137) / (sliderToRadius(sliderValue) * (380 / 256)))}
                            style={{ height: '65vh', width: '100%' }}
                            worldCopyJump={true}
                            scrollWheelZoom="center"
                        >
                            <TileLayer
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                attribution="&copy; OpenStreetMap contributors"
                            />
                            <CenteredCircle
                                radiusKm={sliderToRadius(sliderValue)}
                                center={centerCoords}
                                onCenterChange={setCenterCoords}
                                followMapCenter={isEdit}
                            />
                        </MapContainer>
                        {isEdit && (
                            <>
                                <div style={{ marginTop: '1rem', display: 'flex', alignItems: 'center' }}>
                                    <span style={{ marginRight: '0.5rem' }}>0%</span>
                                    <input
                                        type="range"
                                        min={0}
                                        max={1}
                                        step={0.01}
                                        value={sliderValue}
                                        onChange={handleSliderChange}
                                        style={{ flex: 1 }}
                                    />
                                    <span style={{ marginLeft: '0.5rem' }}>100%</span>
                                </div>

                                <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
                                    <button className='save-btn' type='button' onClick={handleDone}>Save</button>
                                    <button className='save-btn' type='button' onClick={handleCancel}>Discard</button>
                                    {/* <button onClick={handleCancel}>Cancel</button>
                                    <button onClick={handleDone} style={{ backgroundColor: REDLORE_RED, color: 'white' }}>Done</button> */}
                                </div>
                            </>
                        )}
                        {/* <FloorplanPopup className="spaceFloorplan-bounds"  spaceId={spaceId} myMarkers={myMarkers} type={type} windowType={windowType} 
                            moveMarkers={props.location.state.moveMarkers} zoneEditControl={zoneEditControl}>
                            </FloorplanPopup> */}
                    </div>
                </div>
                {/* <LoadingPanel
                      shadingColor="rgba(0,0,0,0.4)"
                      visible={loading}
                      showIndicator={true}
                      showPane={true}
                      shading={true}
                      closeOnOutsideClick={false}
                    /> */}
            </div>
            {/* <MapContainer
                center={mapCenter}
                const zoom = {Math.log2((2 * Math.PI * 6378137) / (sliderToRadius(sliderValue) * (300 / 256)))}
                style={{ height: '80vh', width: '100%' }}
                worldCopyJump={true}
                scrollWheelZoom="center"
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution="&copy; OpenStreetMap contributors"
                />
                <CenteredCircle
                    radiusKm={sliderToRadius(sliderValue)}
                    center={centerCoords}
                    onCenterChange={setCenterCoords}
                    followMapCenter={isEdit}
                />
            </MapContainer> */}

            {/* {isEdit && (
                <>
                    <div style={{ marginTop: '1rem', display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '0.5rem' }}>small</span>
                        <input
                            type="range"
                            min={0}
                            max={1}
                            step={0.01}
                            value={sliderValue}
                            onChange={handleSliderChange}
                            style={{ flex: 1 }}
                        />
                        <span style={{ marginLeft: '0.5rem' }}>large</span>
                    </div>

                    <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
                        <button onClick={handleCancel}>Cancel</button>
                        <button onClick={handleDone} style={{ backgroundColor: REDLORE_RED, color: 'white' }}>Done</button>
                    </div>
                </>
            )} */}
        </div>
    );
};

export default GeoUpload;
